import { render, staticRenderFns } from "./NPAssetPowerUpOptions.vue?vue&type=template&id=0c6cab3e&scoped=true&"
import script from "./NPAssetPowerUpOptions.vue?vue&type=script&lang=js&"
export * from "./NPAssetPowerUpOptions.vue?vue&type=script&lang=js&"
import style0 from "./NPAssetPowerUpOptions.vue?vue&type=style&index=0&id=0c6cab3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6cab3e",
  null
  
)

export default component.exports